<template>
    <div>
        <!--shop wrapper start-->
        <!--shop toolbar start-->
        <div class="shop_title">
            <h3>Sản phẩm sale</h3>
        </div>
        <div class="shop_toolbar_wrapper">
            <div class="shop_toolbar_btn">

                <button data-role="grid_3" type="button" class=" btn-grid-3" data-bs-toggle="tooltip" title="3"></button>

                <button data-role="grid_4" type="button"  class="active btn-grid-4" data-bs-toggle="tooltip" title="4"></button>

                <button data-role="grid_list" type="button"  class="btn-list" data-bs-toggle="tooltip" title="List"></button>
            </div>
        </div>
            <!--shop toolbar end-->

        <div class="row shop_wrapper">
            <div class="col-lg-3 col-md-4 col-6 " v-for="(item, index) in items" :key="index">
                <div class="single_product">
                    <div class="product_thumb">
                        <a class="primary_img" @click="gotoDetail(item.id)"><img :src="domain + '/' + item.path" alt=""></a>
                    </div>

                    <div class="product_content grid_content">
                        <div class="content_inner">
                                <div class="product_name">
                                    <h3><a @click="gotoDetail(item.id)">{{ item.name }}</a></h3>
                                </div>
                                <div class="product_code">
                                    <h3><a @click="gotoDetail(item.id)">Mã sản phầm: {{ item.product_code }}</a></h3>
                                    <h3 v-if="item.made_in">Xuất xứ: {{ item.made_in }}</h3>
                                </div>
                                <div class="price_box">
                                    <template v-if="item.is_sale">
                                        <span class="old_price">{{ item.price | currency }}</span>
                                        <span class="current_price">{{ item.special_price | currency }}</span>
                                    </template>
                                    <span class="current_price" v-else>{{ item.price | currency }}</span>
                                </div>
                            </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="shop_toolbar t_bottom" v-if="total_page">
            <v-pagination v-model="current_page" :length="total_page" :total-visible="7" ></v-pagination>
        </div>
        <!--shop toolbar end-->
        <!--shop wrapper end-->
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import _ from 'lodash';
export default {
    name: "product-sale",
    data() {
        return {
            prev: '<<',
            next: '>>',
            current_page: 1,
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            domain: configs.DOMAIN
        }
    },
    props: {
        title: String,
        page_size: Number,
        list_category: Array
    },
    watch: {
        list_category() {
            this.filter_data();
        },
        search_params() {
            this.filter_data();
        },
        current_page() {
            let params = [];
            if (this.search_params && this.search_params.s) {
                params.push(`s=${this.search_params.s}`)
            }
            params.push(`p=${this.current_page}`)
            window.getApp.$router.push(`/san-pham-sale?${params.join('&')}`).catch(error => {
                if (error.name != "NavigationDuplicated") {
                    throw error;
                }
            });
        }
    },
    computed: {
        ...mapState({
            items: state => state.products.sale.data,
            total_rows: state => state.products.sale.total,
            loading: state => state.products.loading
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        search_params() {
            return this.$route.query;
        },
        total_page() {
            if(this.page_size) {
                return Math.ceil(this.total_rows/this.page_size);
            }
            return Math.ceil(this.total_rows/this.pagination.itemsPerPage);
        }
    },
    methods: {
        filter_data: function (direction = 0) {
            var param = {
                pagination: this.pagination,
                filter: [],
                quickFilter: this.quickFilterConditions
            };
            if(this.page_size) {
                param.pagination.itemsPerPage = this.page_size;
            }
            if (this.search_params && this.search_params.p) {
                this.current_page = Number(this.search_params.p);
            }
            param.pagination.page = this.current_page;
            if(this.list_category && this.list_category.length > 0) {
                param.filter.push({
                    column: "category_id",
                    value: _.map(this.list_category, 'id'),
                    condition: "in",
                });
            }
            param.filter.push({
                column: "is_sale",
                value:1,
                condition: "equal",
            });
            param.filter.push({
                column: "qty",
                value:0,
                condition: "greater_than",
            });
            if (this.search_params && this.search_params.s) {
                param.filter.push({
                    column: "filter_name",
                    value: this.search_params.s,
                    condition: "contain",
                });
            }
            this.$store.dispatch("products/getListSale", param);
            window.scrollTo(0,0);
        },
        gotoDetail(id) {
            window.getApp.$router.push(`/chi-tiet-san-pham/${id}`);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }

}
</script>